import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { IApiConnectedAccount } from '../../types';
import { T_KEYS } from '../../constants';

// Booking logo icon
const BookingLogoIcon = () => (
  <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="52.5" height="52.5" rx="26.25" fill="url(#paint0_linear_293_18962)"/>
    <path d="M22.9907 33.1951L19.4417 33.1916V28.9666C19.4417 28.0639 19.7934 27.5941 20.5693 27.4867H22.9908C24.7176 27.4867 25.8346 28.5707 25.8346 30.3251C25.8346 32.127 24.7458 33.1933 22.9907 33.1951ZM19.4417 21.7995V20.6874C19.4417 19.7143 19.8553 19.2515 20.762 19.1917H22.5789C24.1361 19.1917 25.0693 20.1191 25.0693 21.6728C25.0693 22.8553 24.4295 24.2367 22.6355 24.2367H19.4417V21.7995ZM27.5225 26.0157L26.8809 25.6567L27.4412 25.1798C28.0934 24.622 29.1857 23.3674 29.1857 21.203C29.1857 17.8878 26.6034 15.7498 22.6072 15.7498H18.0472V15.748H17.5275C16.3433 15.792 15.3942 16.7511 15.3818 17.9371L15.3818 36.7479H22.6974C27.139 36.7479 30.0058 34.3406 30.0058 30.6119C30.0058 28.6041 29.0797 26.8885 27.5225 26.0157Z" fill="white"/>
    <path d="M31.9111 34.1523C31.9111 32.7153 33.0752 31.5527 34.5095 31.5527C35.9474 31.5527 37.1169 32.7153 37.1169 34.1523C37.1169 35.5874 35.9474 36.7518 34.5095 36.7518C33.0752 36.7518 31.9111 35.5874 31.9111 34.1523Z" fill="#00BAFC"/>
    <defs>
      <linearGradient id="paint0_linear_293_18962" x1="0" y1="0" x2="52.5" y2="52.5" gradientUnits="userSpaceOnUse">
        <stop stop-color="#013D8E"/>
      </linearGradient>
    </defs>
  </svg>
);

// Arrow icon (back navigation)
const ArrowIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18L15 12L9 6" stroke="#262626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Settings icon
const SettingsIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.14667 1.33398H7.85333C7.49971 1.33398 7.16057 1.47446 6.91053 1.72451C6.66048 1.97456 6.52 2.3137 6.52 2.66732V2.78732C6.51976 3.02113 6.45804 3.25078 6.34103 3.45321C6.22401 3.65564 6.05583 3.82374 5.85333 3.94065L5.56667 4.10732C5.36398 4.22434 5.13405 4.28595 4.9 4.28595C4.66595 4.28595 4.43603 4.22434 4.23333 4.10732L4.13333 4.05398C3.82738 3.87749 3.46389 3.82961 3.12267 3.92086C2.78145 4.0121 2.49037 4.23501 2.31333 4.54065L2.16667 4.79398C1.99018 5.09994 1.9423 5.46343 2.03354 5.80465C2.12478 6.14587 2.34769 6.43695 2.65333 6.61398L2.75333 6.68065C2.95485 6.79699 3.12241 6.96404 3.23937 7.1652C3.35632 7.36637 3.4186 7.59463 3.42 7.82732V8.16732C3.42093 8.40226 3.35977 8.63329 3.2427 8.83699C3.12563 9.04069 2.95681 9.20984 2.75333 9.32732L2.65333 9.38732C2.34769 9.56435 2.12478 9.85543 2.03354 10.1967C1.9423 10.5379 1.99018 10.9014 2.16667 11.2073L2.31333 11.4607C2.49037 11.7663 2.78145 11.9892 3.12267 12.0804C3.46389 12.1717 3.82738 12.1238 4.13333 11.9473L4.23333 11.894C4.43603 11.777 4.66595 11.7154 4.9 11.7154C5.13405 11.7154 5.36398 11.777 5.56667 11.894L5.85333 12.0607C6.05583 12.1776 6.22401 12.3457 6.34103 12.5481C6.45804 12.7505 6.51976 12.9802 6.52 13.214V13.334C6.52 13.6876 6.66048 14.0267 6.91053 14.2768C7.16057 14.5268 7.49971 14.6673 7.85333 14.6673H8.14667C8.50029 14.6673 8.83943 14.5268 9.08948 14.2768C9.33953 14.0267 9.48 13.6876 9.48 13.334V13.214C9.48024 12.9802 9.54196 12.7505 9.65898 12.5481C9.77599 12.3457 9.94418 12.1776 10.1467 12.0607L10.4333 11.894C10.636 11.777 10.866 11.7154 11.1 11.7154C11.3341 11.7154 11.564 11.777 11.7667 11.894L11.8667 11.9473C12.1726 12.1238 12.5361 12.1717 12.8773 12.0804C13.2186 11.9892 13.5096 11.7663 13.6867 11.4607L13.8333 11.2006C14.0098 10.8947 14.0577 10.5312 13.9665 10.19C13.8752 9.84876 13.6523 9.55768 13.3467 9.38065L13.2467 9.32732C13.0432 9.20984 12.8744 9.04069 12.7573 8.83699C12.6402 8.63329 12.5791 8.40226 12.58 8.16732V7.83398C12.5791 7.59904 12.6402 7.36802 12.7573 7.16431C12.8744 6.96061 13.0432 6.79146 13.2467 6.67398L13.3467 6.61398C13.6523 6.43695 13.8752 6.14587 13.9665 5.80465C14.0577 5.46343 14.0098 5.09994 13.8333 4.79398L13.6867 4.54065C13.5096 4.23501 13.2186 4.0121 12.8773 3.92086C12.5361 3.82961 12.1726 3.87749 11.8667 4.05398L11.7667 4.10732C11.564 4.22434 11.3341 4.28595 11.1 4.28595C10.866 4.28595 10.636 4.22434 10.4333 4.10732L10.1467 3.94065C9.94418 3.82374 9.77599 3.65564 9.65898 3.45321C9.54196 3.25078 9.48024 3.02113 9.48 2.78732V2.66732C9.48 2.3137 9.33953 1.97456 9.08948 1.72451C8.83943 1.47446 8.50029 1.33398 8.14667 1.33398Z" stroke="#262626" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="#262626" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);

// Plus icon for add button
const PlusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4.16667V15.8333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4.16669 10H15.8334" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

interface BookingAccountsStepProps {
  connectedAccounts: IApiConnectedAccount[];
  onSelectAccount: (account: IApiConnectedAccount) => void;
  onAddNewAccount: () => void;
  onBack: () => void;
  onOpenSettings?: (accountIndex: number) => void;
  /** When true, only renders the header section without the accounts grid */
  headerOnly?: boolean;
}

const BookingAccountsStep: FC<BookingAccountsStepProps> = ({
  connectedAccounts,
  onSelectAccount,
  onAddNewAccount,
  onOpenSettings,
  onBack,
  headerOnly = false,
}) => {
  const { t } = useTranslation();

  const handleAccountClick = useCallback((account: IApiConnectedAccount) => {
    onSelectAccount(account);
  }, [onSelectAccount]);

  // If headerOnly, just render the header section
  if (headerOnly) {
    return (
      <HeaderSection>
        <HeaderContent>
          <BackButton onClick={onBack}>
            <ArrowIcon />
          </BackButton>
          <HeaderInfo>
            <BookingLogoContainer>
              <BookingLogoIcon />
            </BookingLogoContainer>
            <HeaderTextContent>
              <HeaderTitle>{t(T_KEYS.BOOKING_ACCOUNTS)}</HeaderTitle>
              <HeaderDescription>
                {t(T_KEYS.BOOKING_ACCOUNTS_DESC)}
              </HeaderDescription>
            </HeaderTextContent>
          </HeaderInfo>
        </HeaderContent>
        <AddAccountButton onClick={onAddNewAccount}>
          <PlusIcon />
          <span>{t(T_KEYS.ADD_NEW_BOOKING_ACCOUNT)}</span>
        </AddAccountButton>
      </HeaderSection>
    );
  }

  return (
    <Container>
      {/* Header Section */}
      <HeaderSection>
        <HeaderContent>
          <BackButton onClick={onBack}>
            <ArrowIcon />
          </BackButton>
          <HeaderInfo>
            <BookingLogoContainer>
              <BookingLogoIcon />
            </BookingLogoContainer>
            <HeaderTextContent>
              <HeaderTitle>{t(T_KEYS.BOOKING_ACCOUNTS)}</HeaderTitle>
              <HeaderDescription>
                {t(T_KEYS.BOOKING_ACCOUNTS_DESC)}
              </HeaderDescription>
            </HeaderTextContent>
          </HeaderInfo>
        </HeaderContent>
        <AddAccountButton onClick={onAddNewAccount}>
          <PlusIcon />
          <span>{t(T_KEYS.ADD_NEW_BOOKING_ACCOUNT)}</span>
        </AddAccountButton>
      </HeaderSection>

      {/* Accounts Grid */}
      <AccountsGrid>
        {connectedAccounts.map((account, index) => (
          <AccountCard key={account.id}>
            <AccountCardHeader>
              <AccountTitleSection>
                <AccountTitle>{account.channelName || t(T_KEYS.BOOKING_ACCOUNT_NUMBER, { index: index + 1 })}</AccountTitle>
                <StatusBadge $isActive={account.isChannelActive}>
                  {account.isChannelActive ? t(T_KEYS.CONNECTED) : t(T_KEYS.DISCONNECTED)}
                </StatusBadge>
              </AccountTitleSection>
              <SettingsButton onClick={() => onOpenSettings?.(index)}>
                <SettingsIcon />
              </SettingsButton>
            </AccountCardHeader>

            <AccountStats>
                <StatItem>
                  <StatValue>{account.numberOfConnectedAccounts}</StatValue>
                  <StatLabel>{t(T_KEYS.PROPERTY_LABEL)}</StatLabel>
                </StatItem>
              {account.connectionType === 2 && (
                <StatItem>
                  <StatValue>{account.importedUnits ?? 0}</StatValue>
                  <StatLabel>{t(T_KEYS.UNIT_LABEL)}</StatLabel>
                </StatItem>
              )}
            </AccountStats>

            <ViewPropertiesButton onClick={() => handleAccountClick(account)}>
              {t(T_KEYS.VIEW_PROPERTIES)}
            </ViewPropertiesButton>
          </AccountCard>
        ))}
      </AccountsGrid>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  margin: 0 auto;
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`;

const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const BookingLogoContainer = styled.div`
  width: 52.5px;
  height: 52.5px;
  background: #013d8e;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: right;
`;

const HeaderTitle = styled.h2`
  font-family: 'IBM Plex Sans Arabic', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #262626;
  margin: 0;
`;

const HeaderDescription = styled.p`
  font-family: 'IBM Plex Sans Arabic', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #666666;
  margin: 0;
`;

const AddAccountButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 48px;
  padding: 16px 24px;
  background: #5b3fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;

  span {
    font-family: 'IBM Plex Sans Arabic', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: white;
  }

  &:hover {
    background: #4a2fe6;
  }
`;

const AccountsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
`;

const AccountCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const AccountCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SettingsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: white;
  border: 1px solid #eaeaea;
  border-radius: 20px;
  cursor: pointer;
  padding: 0;
  transition: background 0.2s ease;

  &:hover {
    background: #f8f8f8;
  }
`;

const AccountTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StatusBadge = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  background: ${({ $isActive }) => $isActive ? '#dcfce7' : '#fef2f2'};
  border: 1px solid ${({ $isActive }) => $isActive ? '#bbf7d0' : '#fecaca'};
  border-radius: 100px;
  font-family: 'IBM Plex Sans Arabic', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${({ $isActive }) => $isActive ? '#16a34a' : '#dc2626'};
`;

const AccountTitle = styled.h3`
  font-family: 'IBM Plex Sans Arabic', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #262626;
  margin: 0;
`;

const AccountStats = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
`;

const StatItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 16px;
  background: #f8f8f8;
  border-radius: 16px;
`;

const StatValue = styled.span`
  font-family: 'IBM Plex Sans Arabic', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #262626;
`;

const StatLabel = styled.span`
  font-family: 'IBM Plex Sans Arabic', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
`;

const StatDivider = styled.div`
  width: 1px;
  height: 48px;
  background: #eaeaea;
`;

const ViewPropertiesButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  background: white;
  border: 1px solid #5b3fff;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'IBM Plex Sans Arabic', sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 44px;
  color: #5b3fff;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(91, 63, 255, 0.05);
  }
`;

export default BookingAccountsStep;
